import { Injectable, computed } from '@angular/core';
import { UserSignalrService, UserStore } from '@web-portal/domains/user/data-access';

@Injectable()
export class UserFacade {
  readonly #userStoreService = new UserStore();
  readonly #userSignalrService = new UserSignalrService();

  public readonly user = this.#userStoreService.user;
  public readonly initials = computed(() => this.#userStoreService.user()?.initials ?? '');
  public readonly userSignalrService = this.#userSignalrService;
}
